export class MicroappTenantManListFilter{
    general: string;
}